import { baseUrl } from "../api";

export const bucketsUrl = `${baseUrl}buckets/`;
